import "./App.css";
import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Adminlogin from "./pages/Admin/Adminlogin";
import Loginsuccess from "./pages/Login/Loginsuccess";
import { useJwt } from "react-jwt";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Navbar from "./components/Navbar1/Navbar"
import Sidebar from "./components/Sidebar1/Sidebar"
import Logout from "./pages/Logout/Logout";

function App() {
  const [active, setactive] = useState(true);
  const [isLoggedIn, setisLoggedIn] = useState(false);
  const [modalShow1, setModalShow1] = useState(false);
  const { decodedToken, isExpired } = useJwt(localStorage.getItem("token"));

  useEffect(() => {
    // Check if token is expired or not present
    if (isExpired || !localStorage.getItem("token")) {
      // Clear local storage and set isLoggedIn to false
      localStorage.clear();
      setisLoggedIn(false);
    } else {
      // Token is valid, set isLoggedIn to true
      setisLoggedIn(true);
    }
  }, [isExpired]);

  useEffect(() => {
    // Set isLoggedIn based on local storage
    if (window.localStorage.getItem("isLoggedIn")) {
      setisLoggedIn(true);
    } else {
      setisLoggedIn(false);
    }
  }, []);

  const handlesidebar = () => {
    setactive(!active);
  };

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Routes for login and success pages */}
          {!isLoggedIn ? (
            <>
              <Route exact path='/' element={<Adminlogin setisLoggedIn={setisLoggedIn} />} />
              <Route exact path="/success" element={<Loginsuccess setisLoggedIn={setisLoggedIn} />} />
              <Route exact path="/*" element={<Navigate to="/" />} />
            </>
          ) : (
            // Redirect to Dashboard if isLoggedIn is true
            <Route path="/" element={<Navigate to="/Dashboard" />} />
          )}
        </Routes>

        {/* Sidebar, Navbar, and Logout component when user is logged in */}
        {isLoggedIn && (
          <div className="wrapper">
            <Sidebar active={active} setisLoggedIn={setisLoggedIn} setModalShow1={setModalShow1} />
            <Navbar handlesidebar={handlesidebar} active={active} isLoggedIn={isLoggedIn} setisLoggedIn={setisLoggedIn}/>
          </div>
        )}

        {/* Logout component */}
        <Logout setModalShow1={setModalShow1} modalShow1={modalShow1} setisLoggedIn={setisLoggedIn} />
      </BrowserRouter>

      <ToastContainer />
    </div>
  );
}

export default App;
